<template>
  <div class="list">
    <el-col>
      <el-card class="searchCard" shadow="never">
        <el-form :inline="true" class="demo-inline-form" :model="search_record">
          <el-form-item label="接收时间">
            <el-date-picker
              v-model="getTime"
              type="daterange"
              align="left"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="dateChange"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="处理状态">
            <el-select
              class="search-input"
              v-model="search_record.auditStatus"
              clearable>
              <el-option key="1" label="待提交" :value="1"></el-option>
              <el-option key="2" label="审核中" :value="2"></el-option>
              <el-option key="3" label="审核未通过" :value="3"></el-option>
              <el-option key="4" label="审核通过" :value="4"></el-option>
              <el-option key="5" label="审核终止" :value="5"></el-option>
            </el-select>
          </el-form-item>
          <div v-if="isAgent">
            <el-form-item label="商户编号">
              <el-select
                class="search-input"
                v-model="search_record.FMerchantId"
                placeholder="模糊搜索"
                clearable
                filterable
                remote
                :remote-method="handleMerchantInfoRemote"
                :loading="selectLoading">
                <el-option
                  v-for="item in subMerchantNamesList"
                  :key="item.fmerchantId"
                  :label="item.fmerchantId"
                  :value="item.fmerchantId">
                  <span class="value">{{ item.fmerchantId }}</span>
                  <span class="name">{{ item.fmerchantName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商户简称">
              <el-input
                style="width:160px;"
                placeholder="商户简称"
                v-model="search_record.FMerchantName"
                auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="直属代理商">
              <el-select
                class="search-input"
                v-model="search_record.FDirectlyAgentId"
                placeholder="模糊搜索"
                clearable
                filterable
                :filter-method="handleAgentInfoFilter">
                <el-option
                  v-for="item in subAgentInfoList"
                  :key="item.fAgentId"
                  :label="item.fAgentId"
                  :value="item.fAgentId">
                  <span class="value">{{ item.fAgentId }}</span>
                  <span class="name">{{ item.fTitle }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label="风险来源">
            <el-select
              class="search-input"
              v-model="search_record.FRiskSource"
              placeholder="请选择"
              clearable>
              <el-option key="1" label="微信投诉" value="1"></el-option>
              <el-option key="2" label="微信违规" value="2"></el-option>
              <el-option key="3" label="支付宝违规" value="3"></el-option>
              <el-option key="4" label="云闪付" value="4"></el-option>
              <el-option key="5" label="乐刷" value="5"></el-option>
              <el-option key="6" label="支付宝告警" value="6"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="风险等级">
            <el-select
              class="search-input"
              v-model="search_record.FRiskLevel"
              placeholder="请选择"
              clearable>
              <el-option key="1" label="一" value="1"></el-option>
              <el-option key="2" label="二" value="2"></el-option>
              <el-option key="3" label="三" value="3"></el-option>
              <el-option key="4" label="四" value="4"></el-option>
              <el-option key="5" label="五" value="5"></el-option>
              <el-option key="6" label="六" value="6"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工单号">
            <el-input
              style="width:160px;"
              placeholder="工单号"
              v-model="search_record.FTicketNumber"
              auto-complete="off"></el-input>
          </el-form-item>
          <!--                代理商才显示-->
          <el-form-item label="发展业务员" v-if="isAgent">
            <el-input
              style="width:160px;"
              placeholder="发展业务员"
              v-model="search_record.FOperator"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <auth-button
              opt="search"
              :plain="true"
              icon="el-icon-search"
              @click.native="buttonSearch"
              :loading="checkLoading"
              label="查询"></auth-button>
            <auth-button
              opt="export"
              :plain="true"
              download="风控工单导出.csv'"
              icon="el-icon-download"
              @click.native="buttonExport"
              label="导出"
              :loading="exportLoading"></auth-button>
          </el-form-item>
        </el-form>
        <a class="file-download-button" href="static/各类风险商户申诉资料.xls" download><auth-button opt="download_rule" type="text" label="点击查看各类型风控工单申诉材料"></auth-button></a>
      </el-card>
    </el-col>
    <el-card style="margin-bottom:20px" class="tableCard" shadow="never">
      <el-table
        stripe
        style="width:100%"
        align="center"
        v-loading="listLoading"
        :data="record_list"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="fCreateTime"
          label="接收时间"
          width="95px"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fTicketNumber"
          label="工单号"
          align="center">
        </el-table-column>
        <!--此项商户版不展示-->
        <el-table-column
          prop="fMerchantId"
          label="商户编号"
          align="center"
          v-if="isAgent">
        </el-table-column>
        <!--此项商户版不展示-->
        <el-table-column
          prop="fMerchantName"
          label="商户简称"
          align="center"
          v-if="isAgent">
        </el-table-column>
        <el-table-column
          prop="fDirectlyAgentId"
          label="直属代理商"
          align="center"
          v-if="isAgent">
        </el-table-column>
        <!--此项业务员不展示-->
        <el-table-column
          prop="fOperator"
          label="发展业务员"
          align="center"
          v-if="isAgent">
        </el-table-column>
        <el-table-column
          prop="fDealStateStr"
          label="交易状态"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fSettleStateStr"
          label="结算状态"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fRiskSource"
          label="风险来源"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.fRiskSource === 1">微信投诉</span>
            <span v-if="scope.row.fRiskSource === 2">微信违规</span>
            <span v-if="scope.row.fRiskSource === 3">支付宝违规</span>
            <span v-if="scope.row.fRiskSource === 4">云闪付</span>
            <span v-if="scope.row.fRiskSource === 5">乐刷</span>
            <span v-if="scope.row.fRiskSource === 6">支付宝告警</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fRiskTypeStr"
          label="风险类型"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fRiskLevel"
          label="风险等级"
          align="center">
        </el-table-column>
        <el-table-column
          prop="auditStatus"
          label="处理状态"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.auditStatus === 1" class="red">待提交</span>
            <span v-if="scope.row.auditStatus === 2">审核中</span>
            <span v-if="scope.row.auditStatus === 3" class="red">审核未通过</span>
            <span v-if="scope.row.auditStatus === 4" class="green">审核通过</span>
            <span v-if="scope.row.auditStatus === 5" class="red">审核终止</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fResolveDeadline"
          label="提交期限"
          width="95px"
          align="center">
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          min-width="230"
          :context="_self">
          <template slot-scope="scope">
            <auth-button
              opt="details"
              type="text"
              label="查看"
              @click.native="handleCheck(scope.$index, scope.row)"></auth-button>
            <!-- 待审核和审核不通过有以下按钮-->
            <auth-button
              opt="online_appeal"
              type="text"
              @click.native="handleOnlineAppeal(scope.row)"
              label="在线申诉"
              v-if="scope.row.auditStatus === 1 || scope.row.auditStatus === 3"
              :loading="submitLoading">
            </auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.total>0"
        class="pagination"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>

    <!--        微信支付宝在线申诉-->
    <online-wechat-alipay v-if="onlineDialogVisible" :visible.sync="onlineDialogVisible" :row="editRow" @success="wechatAlipayOnline"></online-wechat-alipay>
    <!--        乐刷、云闪付、微信投诉人工申诉弹窗-->
    <artificial-appeal
      v-if="artificialDialogVisible"
      :visible.sync="artificialDialogVisible"
      :row="editRow"
      @toOnline="handleOnlineAppeal"
      @success="onLineSuccess"></artificial-appeal>
    <!--        乐刷、云闪付、微信投诉在线申诉弹窗-->
    <other-form v-if="otherAppealDialogVisible" :visible.sync="otherAppealDialogVisible" :requestForm="otherAppealForm" @submit="submitSuccess"></other-form>
    <!--        微信、支付宝风控人工申诉弹窗-->
    <artificial-wechat-alipay
      v-if="artificialDialogVisible2"
      :visible.sync="artificialDialogVisible2"
      :row="editRow"
      @toOnline="handleOnlineAppeal"
      @success="onLineSuccess2"></artificial-wechat-alipay>
    <!--        微信不通过仅乐刷解冻在线申诉-->
    <unfreeze-form v-if="unfreezeDialogVisible" :visible.sync="unfreezeDialogVisible" :requestForm="otherAppealForm" @submit="submitSuccess"></unfreeze-form>
  </div>
</template>

<script>
import qs from 'qs'
import onlineWechatAlipay from './components/onlineWechatAlipay'
import artificialAppeal from './components/artificialAppeal'
import artificialWechatAlipay from './components/artificialWechatAlipay'
import otherForm from './components/otherForm'
import unfreezeForm from './components/unfreezeForm'
import { getAllSubMerchantNames, listAgentMerchant } from '@/api/transaction'
import { subAgentInfo } from '@/api/merchant'
import { riskList, riskTicketsDetail, exportRiskTickets } from '@/api/risk'
import { parseAuditStatus } from '@/utils/parseData'
export default {
  name: 'AuditList',
  components: {
    onlineWechatAlipay,
    artificialAppeal,
    artificialWechatAlipay,
    otherForm,
    unfreezeForm
  },
  data () {
    return {
      loading: false, // 整个页面加载
      getTime: [], // 接收时间段
      search_record: {
        FStartTime: '',
        FEndTime: '',
        // FMtlVerifyStatus: '',
        FMerchantId: '',
        FMerchantName: '',
        FDirectlyAgentId: '',
        FRiskSource: '',
        FRiskLevel: '',
        FTicketNumber: '',
        FOperator: '',
        pageNo: 1,
        count: 0,
        auditStatus: 1
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }, // 日期选择快捷键
      selectLoading: false, // 商户编号模糊搜索加载
      subMerchantNamesList: [],
      subMerchantNamesList_back: [],
      subAgentInfoList: [],
      subAgentInfoList_back: [],
      listLoading: false,
      record_list: [],
      roleId: '', // 用户角色
      checkLoading: false,

      onlineDialogVisible: false, // 微信、支付宝风控在线申诉弹窗

      detailDialogVisible: false, // 查看弹窗显示

      otherAppealDialogVisible: false, // 乐刷、云闪付、微信投诉申诉
      otherAppealForm: {}, // 乐刷、云闪付、微信投诉申诉详情请求内容对象

      artificialDialogVisible: false, // 乐刷风控人工申诉弹窗
      artificialDialogVisible2: false, // 微信、支付宝风控人工申诉弹窗
      editRow: {}, // 当前操作的行
      unfreezeDialogVisible: false, // 微信不通过仅乐刷解冻在线申诉

      submitLoading: false, // 接口提交按钮加载
      exportLoading: false, // 导出按钮
      isAgent: this.$store.getters.roleId === 1 || this.$store.getters.roleId === 3
    }
  },
  mounted () {
    this.getDefaultData()
  },
  methods: {
    /**
             * @description 初始加载数据方法
             */
    async getDefaultData () {
      await this.getList()
      // 获取商户编号下拉列表
      if (this.isAgent) {
        await this.getAllSubMerchantNamesFn()
        // 获取直属代理商下拉列表
        await this.getSubAgentInfo()
      }
    },
    /**
             * 日期选中事件
             */
    dateChange (value) {
      if (value !== null) {
        value[0] = value[0].getFullYear() + '-' + (((value[0].getMonth() + 1) < 10) ? ('0' + (value[0].getMonth() + 1)) : (value[0].getMonth() + 1)) + '-' + ((value[0].getDate() < 10) ? ('0' + value[0].getDate()) : (value[0].getDate())) + ' 00:00:00'
        value[1] = value[1].getFullYear() + '-' + (((value[1].getMonth() + 1) < 10) ? ('0' + (value[1].getMonth() + 1)) : (value[1].getMonth() + 1)) + '-' + ((value[1].getDate() < 10) ? ('0' + value[1].getDate()) : (value[1].getDate())) + ' 23:59:59'
        this.search_record.FStartTime = value[0]
        this.search_record.FEndTime = value[1]
      } else {
        this.search_record.FStartTime = ''
        this.search_record.FEndTime = ''
      }
    },
    /**
             * 获取商户编号下拉列表
             */
    getAllSubMerchantNamesFn () {
      return new Promise((resolve, reject) => {
        getAllSubMerchantNames('').then(response => {
          if (response.error_code === '0') {
            this.subMerchantNamesList = response.data
            this.subMerchantNamesList_back = [...this.subMerchantNamesList]
            // this.search_record.FMerchantId = this.subMerchantNamesList.length>0?this.subMerchantNamesList[0].code:'';
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
            resolve(false)
          }
        }).catch((e) => {
          reject(e)
          this.loading = false
        })
      })
    },
    /**
             * 商户编号自定义筛选方法
             */
    async handleMerchantInfoRemote (queryString) {
      if (queryString) {
        this.selectLoading = true
        await this.listAgentMerchantFn(queryString)
        this.selectLoading = false
      } else {
        this.subMerchantNamesList = []
      }
    },
    /**
             * 获取代理商下所有商户列表
             */
    listAgentMerchantFn (merchantId) {
      const params = qs.stringify({
        merchantName: merchantId,
        pageNo: 1,
        pageSize: 50
      })
      return new Promise((resolve, reject) => {
        listAgentMerchant(params).then(response => {
          if (parseInt(response.result_cde) === 0) {
            this.subMerchantNamesList = response.list
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.result_msg,
              type: 'error'
            })
            resolve(false)
          }
        }).catch((e) => {
          reject(e)
          this.loading = false
        })
      })
    },
    /**
             * 直属代理商自定义筛选方法
             */
    handleAgentInfoFilter (queryString) {
      if (queryString) {
        this.subAgentInfoList = this.subAgentInfoList_back.filter(item => {
          return item.fAgentId.toLowerCase().includes(queryString.toLowerCase()) || item.fTitle.toLowerCase().includes(queryString.toLowerCase())
        })
      } else {
        this.subAgentInfoList = this.subAgentInfoList_back
      }
    },
    /**
             * @description 获取下级代理商下拉列表
             */
    getSubAgentInfo () {
      return new Promise((resolve, reject) => {
        // 设一个超大的pageSize取所有数据
        subAgentInfo('pageSize=65535').then(response => {
          if (response.error_code === '0') {
            const userInfo = JSON.parse(localStorage.getItem('ZZGAgentUser')).userEntity
            const agentList = [{
              fAgentId: userInfo.fAgentId,
              fTitle: userInfo.fTitle
            }]
            this.subAgentInfoList = agentList.concat(response.list)
            this.subAgentInfoList_back = [...this.subAgentInfoList]
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
            resolve(false)
          }
        }).catch((e) => {
          reject(e)
          this.loading = false
        })
      })
    },
    /**
             * 请求参数格式化，若为undefined或者null删除属性
             */
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    /**
             * 获取审核列表方法
             */
    getList () {
      this.checkLoading = true
      this.listLoading = true
      this.search_record.FMerchantId = this.search_record.FMerchantId && this.search_record.FMerchantId.replace(/ /g, '')
      this.search_record.FMerchantName = this.search_record.FMerchantName && this.search_record.FMerchantName.replace(/ /g, '')
      var data = this.formatSearch(this.search_record)
      data = qs.stringify(data)
      riskList(data).then((data) => {
        this.checkLoading = false
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.listLoading = false
        } else {
          this.listLoading = false
          this.checkLoading = false
          this.paginations.total = data.data.totalCount
          this.record_list = data.data.list.map(item => {
            item.auditStatus = parseAuditStatus(item.fTicketStatus, item.fMtlVerifyStatus)
            return item
          })
          this.salesNum = data.data.totalCount
          this.search_record.count = data.data.totalCount
        }
      })
    },
    /**
             * 查询按钮
             */
    buttonSearch () {
      // 当点击查询时，显示第一页
      this.search_record.pageNo = 1
      this.search_record.count = 0
      // 让页码数回归到1
      this.paginations.total = 0
      this.onSearch()
    },
    /**
             * 列表查询事件
             */
    onSearch () {
      this.checkLoading = true
      this.getList()
    },
    /**
             * 根据id获取申诉记录详情
             */
    getRow (id) {
      var data = {
        ticketNumber: id
      }
      var that = this
      data = qs.stringify(data)
      riskTicketsDetail(data).then((data) => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          //    赋值给agentForm
          that.agentForm = data.data
        }
      })
    },
    /**
             * 查看风控审核记录
             */
    async handleCheck (index, row) {
      // this.detailDialogVisible = true;
      this.$router.push({ path: `/Risk/RiskManage/checkDetails/${row.fTicketNumber}` })
    },
    /**
             * 在线申诉
             */
    async handleOnlineAppeal (row) {
      // 乐刷、云闪付、微信投诉
      if ([1, 5, 6].includes(row.fAppealInfoType)) {
        this.artificialDialogVisible = false
        this.otherAppealForm = {
          ticketNumber: row.fTicketNumber,
          merchantId: row.fMerchantId,
          appealInfoType: row.fAppealInfoType,
          riskSource: row.fRiskSource
        }
        this.otherAppealDialogVisible = true
      } else {
        // 微信、支付宝、乐刷解冻
        this.artificialDialogVisible2 = false
        this.editRow = row
        this.onlineDialogVisible = true
      }
    },
    /**
             * 去人工申诉
             */
    handleArtificialAppeal (row) {
      if (row.fAppealInfoType === 1 || row.fAppealInfoType === 6) {
        this.artificialDialogVisible = true
      } else {
        this.artificialDialogVisible2 = true
      }
      this.editRow = row
    },
    /**
             * 乐刷风控人工申诉弹窗，提交成功回调
             */
    onLineSuccess () {
      this.artificialDialogVisible = false
      this.record_list = []
      this.getList()
    },
    /**
             * 微信、支付宝人工申诉弹窗，成功回调
             */
    onLineSuccess2 () {
      this.artificialDialogVisible2 = false
      this.record_list = []
      this.getList()
    },
    /**
             * @description 改变当前页事件
             * @param  {number} page 当前页码
             */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.search_record.pageNo = page
      this.onSearch()
    },
    /**
             * @description 上传图片成功
             * @param  {object} data 上传成功接口返回数据及该数据对应属性名
             */
    uploadSuccess (data) {
      this[data.valueName] = data.path
    },
    /**
             * @description 提交模板表单成功
             */
    submitSuccess () {
      this.record_list = []
      this.getList()
    },
    /**
             * 关闭微信、支付宝在线申诉弹窗
             */
    closeOnline (value) {
      this.onlineDialogVisible = value
    },
    /**
             * 微信、支付宝在线申诉弹窗提交成功
             */
    wechatAlipayOnline (value) {
      if (value.type === 'failed') {
        this.otherAppealForm = value.otherAppealForm
        this.unfreezeDialogVisible = true
      } else {
        this.record_list = []
        this.getList()
      }
    },
    /**
             * 微信、支付宝在线申诉弹窗提交成功
             */
    buttonExport () {
      // 当点击查询时，显示第一页
      this.search_record.pageNo = 1
      this.exportLoading = true
      this.exportList()
    },
    exportList () {
      var data = this.formatSearch(this.search_record)
      data = qs.stringify(data)
      exportRiskTickets(data).then(response => {
        this.exportLoading = false
        // 弹出下载框
        const url = window.URL.createObjectURL(new Blob([response]))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', '风控工单导出.csv')
        document.body.appendChild(link)
        link.click()
      })
    }
  }
}
</script>

<style scoped>
    .list{
        padding-left: 16px;
    }
    .btm-action {
        margin: 20px 0;
        text-align: center;
    }
    .red{
        color: #ff7070;
    }
    .green{
        color: #77d580;
    }
</style>
